export default __webpack_public_path__ + "static/Ellipse 3-c82d315472a51d71986505f9a2c1fd6a.png";